export class BrandData {
  pageType: string = 'default';
  view: string = '';
  trackingSrc: string = '';
  abLogoSrc: string = '';
  logoSrc: string = '';
  logoBottomSrc: string = '';
  logoWasabiSrc: string = '';
  tyLogoSrc: string = '';
  domain: string = '';
  prettyDomain: string = 'FreeRateUpdate';
  isTop10: boolean = false;
}
